var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackStepBgXs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 36,
    viewBox: "0 0 251 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 17,
    transform: "matrix(1 0 0 -1 0 17.4072)",
    fill: "#292B33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 17,
    transform: "matrix(1 0 0 -1 0 35.4072)",
    fill: "#292B33"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 35.4072,
    width: 17,
    height: 1.00001,
    transform: "rotate(-90 250 35.4072)",
    fill: "#292B33"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 35.4072,
    width: 17,
    height: 1.00001,
    transform: "rotate(-90 239 35.4072)",
    fill: "#292B33"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 35.4072,
    width: 17,
    height: 1.00001,
    transform: "rotate(-90 248 35.4072)",
    fill: "#292B33"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 35.4072,
    width: 17,
    height: 1.00001,
    transform: "rotate(-90 241 35.4072)",
    fill: "#292B33"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 35.4072,
    width: 17,
    height: 2.00001,
    transform: "rotate(-90 243 35.4072)",
    fill: "#292B33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackStepBgXs);
export default __webpack_public_path__ + "static/media/black-step-bg-xs.c2b6737359842146278d92ffc4a08a57.svg";
export { ForwardRef as ReactComponent };